import React from "react";
import cx from "classnames";
import s from "./Landing.module.scss";

import Logo from "assets/images/newest-ui/att-globe.png"
import Background from "assets/images/2024-ui/background-1.jpg"
import Glow from "assets/images/2024-ui/home-ambient-glow.png";
import Ribbon from "assets/images/2024-ui/ribbon-present.png";
import Bear from "assets/images/bear-sled.png"
import LangSelect from "assets/images/newest-ui/landing/language-select.png";

import BackgroundCorners from "components/BackgroundCorners";

import store from "store";
import { setState } from "store/ui";
import AudioManager from "scripts/util/AudioManager";
import { useSelector } from "react-redux";
import useQuery from "hooks/useQuery";

Landing.defaultProps = {};

export default function Landing(props) {
  const { onComplete } = props;
  const { showLeaderboard } = useSelector((state) => state.ui);
  let lang = useQuery().get("lang") || "en";

  const translate = {
    languageSelect: {
      en: {
        text: "Español",
        url: "?lang=es"
      },
      es: {
        text: "English",
        url: "?lang=en"
      }
    },
    titleImage : {
      en: {
        img: require("assets/images/en/landing/title-landing.svg").default,
        alt: "Dashing to the Store"
      },
      es: {
        img: require("assets/images/es/landing/title-landing.png").default,
        alt: "De prisa a la tienda"
      },
    },
    ctaButton: {
      en: "Let's play!",
      es: "¡Vamos a jugar!"
    },
    leaderboardLink: {
      en: "National Leaderboard",
      es: "Tablero nacional de posiciones"
    }
  }

  // alert(lang);

  const onSubmit = () => {
    AudioManager.playSound("uiAccept");
    onComplete();
  };

  return (
    <div className={s.Landing}>
      { !showLeaderboard &&
        <a href={`/holidaygame${translate.languageSelect[lang].url}`} className={s.langSelect}><img src={LangSelect} alt="" />
          {translate.languageSelect[lang].text}
        </a>
      }
      <img src={Logo} className={s.logo}  alt="AT&T globe" />
      <div className={s.background}>
        <img className={s.bg} src={Background} alt="" />
        <img className={s.bg} src={Glow} alt="" />
        <img src={Ribbon} className={s.ribbon}  alt="flowing red ribbon with a blue and red present floating over it" />
        <BackgroundCorners />
      </div>
      <div className={s.content}>
        <div className={s.contentInner}>
          <img className={s.title} src={translate.titleImage[lang].img} alt={translate.titleImage[lang].alt} />
          <button className="btn md" onClick={onSubmit}>
            {translate.ctaButton[lang]}
          </button>
          <button
            className={cx(s.link, "link")}
            onClick={() => {
              AudioManager.playSound("uiSelect");
              store.dispatch(setState({ showLeaderboard: true }));
            }}
          >
            {translate.leaderboardLink[lang]}
          </button>
        </div>
      </div>
      <img src={Bear} className={s.bear}  alt="bear on a sled" />
    </div>
  );
}
